import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const LoginButton = ({ path }) => (
  <Link
    className="nav-btn"
    to="/login"
    state={path}
  >
    <span className="btn btn-sm m-1 flex-fill">Login</span>
  </Link>
);

export default connect()(LoginButton);
